<template>
  <backbar-page-layout
    back-title="title.user_details"
    title="title.profile"
    :user-id="id"
    :loading="isLoadingStatus"
  >
    <template #alert>
      <b-row>
        <b-col>
          <b-alert
            :show="updateProfileDone"
            variant="success"
          >
            {{ $t('status.success.update_profile') }}
          </b-alert>
        </b-col>
      </b-row>
    </template>
    <b-container class="mt-4">
      <b-form @submit="update">
        <h5 class="font-weight-bold">{{ $t('title.edit_profile') }}</h5>
        <hr/>
        <b-row class="mt-5 mb-4" align-h="center">
          <b-col cols="4">
            <b-bsq-input
              v-model="updatedUser.username"
              :label="$t('input.username')"
            />
          </b-col>
        </b-row>
        <b-row class="mb-5" align-h="center">
          <b-col cols="4">
            <b-bsq-input
              v-model="updatedUser.displayName"
              :label="$t('input.name')"
            />
          </b-col>
        </b-row>
        <b-row class="mb-4" align-h="center">
          <b-col cols="4">
            <b-button block type="submit" variant="primary">
              {{ $t('button.save') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-container>
  </backbar-page-layout>
</template>

<script>
import { mapState } from 'vuex'

import BackbarPageLayout from '@/components/BackbarPageLayout'

import store from '@/store'

export default {
  name: 'UserDetailsProfile',
  components: {
    BackbarPageLayout
  },
  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      username: '',
      displayName: '',
      updatedUser: {}
    }
  },

  computed: {
    ...mapState('client', [
      'authenticated'
    ]),
    ...mapState('management/userDetails', [
      'loading',

      'user'
    ]),
    ...mapState('management/userDetails/updateUserForm', {
      updateProfileDone: state => state.done
    }),
    isLoadingStatus () {
      return !this.authenticated || this.loading
    }
  },

  mounted () {
    this.updatedUser = Object.assign({}, this.user)
  },

  destroyed () {
    store.commit('management/userDetails/updateUserForm/CLEAR_STATES')
  },

  methods: {
    async update (e) {
      e.preventDefault()
      await store.dispatch('management/userDetails/updateUserForm/update', this.updatedUser)
    }
  }
}
</script>
